function getNewsTypeName (typeID) {
  // console.log(typeof (this.typeID))
  if (typeID === 0) { return '最新资讯' } else if (typeID === 1) { return '最新新闻' } else if (typeID === 2) { return '最新公告' } else if (typeID === 3) { return '最新活动' }
}
function getNewsTypeShortName (typeID) {
  // console.log(typeof (this.typeID))
  if (typeID === 0) { return '资讯' } else if (typeID === 1) { return '新闻' } else if (typeID === 2) { return '公告' } else if (typeID === 3) { return '活动' }
}
function getNewsTypeNameEnglish (typeID) {
  if (typeID === 0) { return 'NEW INFOMATION' } else if (typeID === 1) { return 'NEWS' } else if (typeID === 2) { return 'NOTICE' } else if (typeID === 3) { return 'ACTIVITY' }
}
function getStrateTypeName (typeID) {
  // console.log(typeof (this.typeID))
  if (typeID === 0) { return '江湖攻略' } else if (typeID === 1) { return '新人' } else if (typeID === 2) { return '攻略' }
}
function getStrateTypeNameEnglish (typeID) {
  if (typeID === 0) { return 'ZHUJIAN STRATE' } else if (typeID === 1) { return 'NOVICE' } else if (typeID === 2) { return 'STRATE' }
}
function getIntroTypeName (typeID) {
  // console.log(typeof (this.typeID))
  if (typeID === 1) { return '副本地图' } else if (typeID === 2) { return '物品介绍' } else if (typeID === 3) { return '武功介绍' } else if (typeID === 4) { return '装备介绍' } else if (typeID === 5) { return '游戏特色' }
}
export { getNewsTypeName, getNewsTypeNameEnglish, getStrateTypeName, getStrateTypeNameEnglish, getNewsTypeShortName, getIntroTypeName }



// WEBPACK FOOTER //
// ./src/utils/utils.js